import {
  fetchCommunicationUserMappingValues,
  createUserMappingValues,
} from '../../../routines/integrations/communicationRoutines';

const initialState = {
  mappingValues: [],
  mappingLoading: true,
  error: false,
};

const communicationUserMappingReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchCommunicationUserMappingValues.TRIGGER:
      return {
        ...state,
        mappingLoading: true,
        error: false,
      };

    case fetchCommunicationUserMappingValues.SUCCESS: {
      const { mappingValues } = action.payload;
      if (mappingValues) {
        const newMappingValues = mappingValues.map(
          ({ vendorValue, velarisValue }) => ({
            vendorValue,
            velarisValue,
          })
        );

        return {
          ...state,
          mappingLoading: false,
          mappingValues: newMappingValues,
        };
      }

      return {
        ...state,
        mappingLoading: false,
      };
    }
    case fetchCommunicationUserMappingValues.FAILURE:
      return {
        ...state,
        mappingLoading: false,
      };

    case createUserMappingValues.TRIGGER:
      return {
        ...state,
        error: null,
      };

    case createUserMappingValues.SUCCESS: {
      const { mappingValues } = action.payload;
      const newMappingValues = mappingValues.map(({ vendor, velaris }) => ({
        vendorValue: vendor,
        velarisValue: velaris,
      }));

      return {
        ...state,
        mappingValues: newMappingValues,
        mappingLoading: false,
        error: false,
      };
    }

    case createUserMappingValues.FAILURE:
      return {
        ...state,
        mappingLoading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

export default communicationUserMappingReducer;
